import {Address} from "@/util/Address";
import {User} from "@/util/User";
import {ResponseCustomerInterface} from "@/types/ResponseCustomer";

export class ResponseCustomer implements ResponseCustomerInterface {
  customer: User;
  shippingAddress: Address;
  billingAddress: Address;

  invoiceRecipient?: User;
  invoiceRecipientShippingAddress?: Address;
  invoiceRecipientBillingAddress?: Address;

  constructor(invoiceRecipient: User, customer?: User) {
    if (!customer) {
      this.customer = invoiceRecipient;
      this.shippingAddress = invoiceRecipient.address;
      this.billingAddress = invoiceRecipient.address;
    } else {
      this.customer = customer;
      this.shippingAddress = customer.address;
      this.billingAddress = invoiceRecipient.address
        ? invoiceRecipient.address
        : customer.address;
      this.invoiceRecipient = invoiceRecipient;
      this.invoiceRecipientShippingAddress = invoiceRecipient.address;
      this.invoiceRecipientBillingAddress = invoiceRecipient.address;
    }
  }
}
